import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { FoodsScreen } from './FoodsScreen';
import type { FoodsSearch } from './foods-search';

const route = getRouteApi('/foods');

export function FoodsRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();
  const navigateTo = useNavigate();

  const onSearchChange = useCallback(
    (next: FoodsSearch) => {
      void navigate({
        // `replace` keeps typing in the search box from filling the history
        // stack with one entry per debounce.
        replace: true,
        // A cleared filter leaves the URL entirely rather than lingering as
        // `?source=`. See `definedSearchParams` for why this is not spelled
        // out key by key any more.
        search: () => definedSearchParams(next),
      });
    },
    [navigate],
  );

  const onNewFood = useCallback(() => {
    void navigateTo({ to: '/foods/new' });
  }, [navigateTo]);

  const onOpenFood = useCallback(
    (foodId: string) => {
      void navigateTo({ to: '/foods/$foodId', params: { foodId } });
    },
    [navigateTo],
  );

  return (
    <FoodsScreen
      search={search}
      onSearchChange={onSearchChange}
      onNewFood={onNewFood}
      onOpenFood={onOpenFood}
    />
  );
}
